import { useCallback, useEffect, useState } from 'react';

const useOptimisticValueReact17 = value => {
  const [optimisticValue, setOptimisticValue] = useState(value);

  useEffect(() => {
    setOptimisticValue(value);
  }, [value]);

  const setOptimisticValueWithCallback = useCallback((newValue, callback) => {
    setOptimisticValue(newValue);
    setTimeout(() => {
      callback?.();
    }, 0);
  }, []);

  return [optimisticValue, setOptimisticValueWithCallback];
};

export default useOptimisticValueReact17;
